import React, { useState } from 'react';
import { agruparPorMes, formatCLP, formatFecha } from '../lib/format';
import { abrirComprobante, nombreRubro } from '../lib/comprobantes';

// Lista de movimientos agrupada por mes, con totales por mes y meses plegables.
// El mes más reciente se muestra abierto; los anteriores, cerrados.
function MovimientosPorMes({ movimientos, bolsillos, comprobantes = [], onEdit, onDelete, onError }) {
  const grupos = agruparPorMes(movimientos);
  const [abiertos, setAbiertos] = useState(() => new Set(grupos.length ? [grupos[0].clave] : []));

  const toggle = (clave) => setAbiertos(prev => {
    const next = new Set(prev);
    if (next.has(clave)) next.delete(clave); else next.add(clave);
    return next;
  });

  return (
    <div className="meses-list">
      {grupos.map(g => {
        const ingresos = g.registros.filter(m => m.tipo === 'ingreso').reduce((s, m) => s + Number(m.monto), 0);
        const egresos = g.registros.filter(m => m.tipo === 'egreso').reduce((s, m) => s + Number(m.monto), 0);
        const balance = ingresos - egresos;
        const abierto = abiertos.has(g.clave);
        return (
          <div key={g.clave} className="mes-grupo">
            <button type="button" className="mes-header" onClick={() => toggle(g.clave)}>
              <span className="mes-chevron">{abierto ? '▼' : '▶'}</span>
              <span className="mes-nombre">
                {g.nombre}
                <span className="mes-count">{g.registros.length} mov.</span>
              </span>
              <span className="mes-totales">
                <span className="text-success">+{formatCLP(ingresos)}</span>
                <span className="text-danger">−{formatCLP(egresos)}</span>
                <strong className={balance >= 0 ? 'text-success' : 'text-danger'}>
                  {balance >= 0 ? '+' : '−'}{formatCLP(Math.abs(balance))}
                </strong>
              </span>
            </button>
            {abierto && (
              <div className="movimientos-list mes-body">
                {g.registros.map(mov => {
                  const bolsillo = bolsillos?.find(b => b.id === mov.bolsillo_id);
                  return (
                    <div key={mov.id} className="movimiento-item">
                      <div className="mov-info">
                        <span className={`mov-tipo-badge ${mov.tipo}`}>{mov.tipo === 'ingreso' ? '↑' : '↓'}</span>
                        <div>
                          <span className="mov-desc">
                            {bolsillo && <strong>{bolsillo.nombre} — </strong>}
                            {mov.descripcion || (mov.tipo === 'ingreso' ? 'Entrada' : 'Salida')}
                          </span>
                          <span className="mov-fecha">
                            {formatFecha(mov.fecha)}{mov.rubro ? ` · ${nombreRubro(mov.rubro)}` : ''}
                          </span>
                        </div>
                      </div>
                      <div className="mov-right">
                        <span className={`mov-monto ${mov.tipo === 'ingreso' ? 'text-success' : 'text-danger'}`}>
                          {mov.tipo === 'ingreso' ? '+' : '-'}{formatCLP(mov.monto)}
                        </span>
                        {comprobantes.filter(c => c.movimiento_id === mov.id).slice(0, 1).map(c => (
                          <button key={c.id} className="btn-icon-del small" title="Ver comprobante"
                            onClick={() => abrirComprobante(c).catch(e => onError?.(e.message || String(e)))}
                            style={{ fontSize: '0.9rem' }}>📎</button>
                        ))}
                        {onEdit && (
                          <button className="btn-icon-del small" title="Editar" onClick={() => onEdit(mov)}
                            style={{ color: 'var(--primary)', fontSize: '0.9rem' }}>✎</button>
                        )}
                        {onDelete && (
                          <button className="btn-icon-del small" title="Eliminar" onClick={() => onDelete(mov)}>×</button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default MovimientosPorMes;
